import React, { useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components//Footer/footer";
import StepRoutes from "../../../Kryzen Alpha App/Routes/steps_routes";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import Pagination from "../../../Kryzen Alpha App/Components/layouts/pagination";
import getFilteredURL from "../../../Kryzen Alpha App/Components/Functions/filters.getUrl";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcCurrencyExchange } from "react-icons/fc";
import FarmingConferenceTable from "./farmingConferenceTable";

const FarmingConferencePayment = () => {
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    status: "",
    name: "",
  });
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [count, setCount] = useState();

  useEffect(() => {
    performRequest("GET", `/thefarmingconference/payment-count/`)
      .then((res) => {
        if (res.status === 200) {
          setCount(res.data);
        } else {
          Toast("error", "Error while getting payments list!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL(`/thefarmingconference/get-payements/`, page, filters)
    )
      .then((res) => {
        if (res.status === 201) {
          setData(res.data.thefarmingConferencesInfo);
        } else {
          Toast("error", "Error while getting payments list!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh]);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title">
                    <FcCurrencyExchange className="fs-2 me-1" />
                    Farming Conference Payments
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="container-xxl">
              <div className="row">
                <div className="col-md-3 col-sm-12 py-2">
                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div className="accordion-body pt-0">
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Start Date:"
                                  value={filters.startdate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="End Date:"
                                  value={filters.enddate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Payment Status:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      status: e.target.value,
                                    })
                                  }
                                  value={filters.status}
                                >
                                  <option value="">Select</option>
                                  <option value="success">Completed</option>
                                  <option value="failure">Pending</option>
                                </DynamicFilterSelect>
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Enter Name:"
                                  value={filters.name}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      name: e.target.value,
                                    })
                                  }
                                  type="name"
                                />
                              </div>

                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => setRefresh(!refresh)}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setFilters({
                                          startdate: "",
                                          enddate: "",
                                          status: "",
                                          name: "",
                                        });
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-body d-none d-md-block">
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Start Date:"
                                value={filters.startdate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="End Date:"
                                value={filters.enddate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Payment Status:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    status: e.target.value,
                                  })
                                }
                                value={filters.status}
                              >
                                <option value="">Select</option>
                                <option value="success">Completed</option>
                                <option value="failure">Pending</option>
                              </DynamicFilterSelect>
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Enter Name:"
                                value={filters.name}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    name: e.target.value,
                                  })
                                }
                                type="name"
                              />
                            </div>
                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => setRefresh(!refresh)}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        startdate: "",
                                        enddate: "",
                                        status: "",
                                        name: "",
                                      });
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-9 col-sm-12 py-2">
                  <div className="row row-deck mb-3">
                    <div className="col-12 col-md-4 col-lg-4">
                      <div className="card bg-primary-lt card-sm">
                        <div className="card-body">
                          <div className="">
                            <h1 className="text-center hero-title display-6 fw-bold">
                              {count?.totalRegistered}
                            </h1>
                            <div className="fw-bold fs-4 text-center text-uppercase">
                              Total Registered
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-4 col-lg-4 mb-2">
                      <div className="card bg-primary-lt card-sm">
                        <div className="card-body">
                          <div className="">
                            <h1 className="text-center hero-title display-6 fw-bold ">
                              {count?.totalSuccess} / {count?.totalFailed}
                            </h1>
                            <div className="fw-bold fs-4 text-center text-uppercase">
                              Success / Failed Payments
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-4 col-lg-4 mb-2">
                      <div className="card bg-primary-lt card-sm">
                        <div className="card-body">
                          <div className="">
                            <h1 className="text-center hero-title display-6 fw-bold ">
                              ₹{count?.totalRevenue}
                            </h1>
                            <div className="fw-bold fs-4 text-center text-uppercase">
                              Total Revenue
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <FarmingConferenceTable
                      data={data}
                      currentPage={page}
                      itemsPerPage={50}
                    />
                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default FarmingConferencePayment;
